export default {
  effect: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500039E","整单生效") /* "整单生效" */,
  enableContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500039F","确定执行整单生效?") /* "确定执行整单生效?" */,
  delContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE050003A0","确定删除该项吗?") /* "确定删除该项吗?" */,
  operationSuccess: lang.templateByUuid("UID:P_UDHWN_17DD50DE050003A1","操作成功") /* "操作成功" */,
  item: lang.templateByUuid("UID:P_UDHWN_17DD50DE050003A2","条") /* "条" */,
  endTimeBeGreaterThanStartTime: lang.templateByUuid("UID:P_UDHWN_17DD50DE050003A3","结束时间必须大于开始时间") /* "结束时间必须大于开始时间" */,
  endTimeBeGreaterThanCurrentTime: lang.templateByUuid("UID:P_UDHWN_17DD50DE050003A4","结束时间必须大于当前时间") /* "结束时间必须大于当前时间" */
};
